var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPioneerEnterprise(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 51,
    viewBox: "0 0 40 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.5627 0H0V50.1744H39.5627V0ZM2.64544 2.67994H36.7092V47.4944H2.64544V2.67994Z",
    fill: "#BDCCD4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7879 8.93457H9.75391V12.2398H29.7879V8.93457Z",
    fill: "#0AE8F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7879 15.0669H9.75391V18.3722H29.7879V15.0669Z",
    fill: "#0AE8F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.393 34.2747H7.60742V42.2251H12.393V34.2747Z",
    fill: "#006BFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.895 24.7145H14.1094V42.1936H18.895V24.7145Z",
    fill: "#006BFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4242 27.7534H20.6387V42.2251H25.4242V27.7534Z",
    fill: "#006BFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9272 38.3239H27.1416V42.1949H31.9272V38.3239Z",
    fill: "#006BFF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPioneerEnterprise);
export default __webpack_public_path__ + "static/media/pioneer_enterprise.030650899d016fb86c4d87ec0170fb28.svg";
export { ForwardRef as ReactComponent };